<template>
  <ul
    :style="{
      display: 'flex',
      flexWrap: 'wrap',
      marginTop: '12px',
    }"
    v-loading="loading"
  >
    <template v-if="list.length > 0">
      <li v-for="item in list" :key="item.id" class="good-item">
        <el-card shadow="always">
          <div v-if="item.isTop" class="goods-tag">推荐</div>
          <div class="top-info">
            <div class="left-checked">
              <el-checkbox
                :value="item.ischecked"
                @change="handleChange($event, item)"
              ></el-checkbox>
            </div>
            <div class="right-image text-pointer" @click="toProductDetail(item)">
              <el-image :src="item.mainImages[0]" fit="contain"></el-image>
            </div>
          </div>
          <div class="middle-info">
            <div class="flex space-between">
              <div class="mar-10 distributor-price">
                分销价：
                <strong
                  v-if="item.levelDistributionPrice === -1"
                  class="text-orange ftsz16"
                >
                  合作后查看
                </strong>
                <strong
                  v-else
                  style="color: #ff0000; font-size: 16px"
                >
                  ￥{{ item.levelDistributionPrice }}
                </strong>
                <!-- 不是合作中但是有分销价的显示合作后更优惠 -->
                <strong
                  v-if="item.levelDistributionPrice !== -1 && isInCooperation !== 2"
                  class="text-green"
                >
                  合作后更优惠
                </strong>
              </div>
              <div class="mar-10 distributor-price">
                月销量：
                <strong
                  class="text-orange ftsz16"
                >
                  -
                </strong>
              </div>
            </div>
            
            <!-- <div class="mar-10 sale-price">
              零售价：<span>￥{{ item.salesPrice }}</span>
            </div> -->
            <div class="mar-10 goods-name">
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.title"
                placement="top-start"
              >
                <span> {{ item.title }}</span>
              </el-tooltip>
            </div>
            <div class="mar-10 outer-code">
              款式编码：<el-tooltip
                class="item"
                effect="dark"
                :content="item.outerId"
                placement="top-start"
              >
                <span>{{ item.outerId }}</span>
              </el-tooltip>
            </div>
            <div class="can-plateform">
              <CanPublishPlatform
                :canPublishPlatform="item.canPublishPlatform"
              />
            </div>
          </div>
          <div class="bottom-info">
            <el-tooltip class="item" placement="top" content="一键铺货">
              <div class="text-pointer" @click="$emit('shelves', item)">
                <i class="el-icon-top"></i>
              </div>
            </el-tooltip>
            <el-tooltip class="item" placement="top" content="加入分销商品">
              <div class="text-pointer relative mgl12" @click="$emit('join', item)">
                <i class="el-icon-circle-plus-outline"></i>
                <!-- 已加入分销商品 -->
                <i v-if="item.isDistributor" class="el-icon-success isDistributor"></i>
              </div>
            </el-tooltip>
            <!-- <el-button type="text" @click="$emit('import', item)"
              >导入商品</el-button
            > -->
          </div>
        </el-card>
      </li>
    </template>
    <template v-else>
      <el-col
        style="
          line-height: 60px;
          color: #909399;
          text-align: center;
          font-size: 12px;
        "
      >
        暂无数据
      </el-col>
    </template>
  </ul>
</template>

<script>
import tableMixins from "@mixins/table-mixins";
import CanPublishPlatform from "./canPublishPlatform.vue";
export default {
  mixins: [new tableMixins(319, { refName: "search" })],
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    loading: Boolean,
    isInCooperation: Number,
  },
  components: {
    CanPublishPlatform,
  },
  data() {
    return {
      selectedArr: [],
    };
  },
  watch: {
    // list:{
    //   handler(newVal){
    //     //this.goodList = newVal;
    //     console.log(newVal);
    //   },
    //   deep: true
    // }
  },
  computed: {
    rowHeight() {
      return {
        height: `${this.autoHeight}px`,
      };
    },
  },
  methods: {
    handleChange(e, item) {
      item.ischecked = e;
      if (e) {
        this.selectedArr.push({ ...item });
      } else {
        const index = this.selectedArr.findIndex(value => {
          return value.id === item.id;
        });
        if (index === -1) return;
        this.selectedArr.splice(index, 1);
      }
      this.$emit('updateSelectedGoods', this.selectedArr);
    },
    method_getSelectedArr() {
      return this.selectedArr;
    },
    methods_clearSelectedArr() {
      this.selectedArr = [];
    },

    toProductDetail(item) {
      this.$router.push({
        name: 'un_productDetail',
        query:{
          supplierId: item.companyId,
          productId: item.baseItemId
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.good-item {
  width: 20%;
  min-width: 20%;
  position: relative;
}
.goods-tag {
  position: absolute;
  background-color: #2695FA;
  right: 34px;
  top: 28px;
  z-index: 10;
  border-radius: 4px;
  color: #fff;
  padding: 2px 8px;
}
.top-info {
  display: flex;
  align-items: flex-start;
  position: relative;
  margin: -20px -20px 0 -20px;
  .left-checked {
    position: absolute;
    top: 12px;
    left: 12px;
  }
  .right-image {
    flex: 1;
    height: 15vw;
    .el-image {
      height: 100%;
      width: 100%;
      object-fit: fill;
      object-position: top;
    }
  }
}
::v-deep .el-image__inner {
  object-fit: contain;
  object-position: center;
}
::v-deep .el-card {
  margin: 0 5px 5px 5px;
  .el-card__body {
    padding-bottom: 0;
  }
}
.middle-info {
  font-size: 14px;
  padding: 10px 0;
  .mar-10 {
    margin-bottom: 10px;
  }
  .distributor-price {
    height: 20px;
    line-height: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .mar-r-10 {
    margin-right: 10px;
  }
  .sale-price {
    color: #909399;
    height: 18px;
    line-height: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .goods-name {
    height: 52px;
    // line-height: 16px;
    font-size: 16px;
    overflow: hidden;
    font-weight: bold;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .outer-code {
    color: #909399;
    height: 16px;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .can-plateform {
    display: flex;
    align-items: center;
    height: 25px;
  }
}
.bottom-info {
  background-color: #dadada;
  margin: 0 -20px;
  padding: 6px 20px;
  display: flex;
  justify-content: flex-end;
  color: #666;
  font-size: 18px;
  .el-button {
    padding: 5px;
  }
  .isDistributor {
    position: absolute;
    font-size: 14px;
    color: rgb(31, 162, 1);
    bottom: 2px;
    right: -3px;
  }
}
</style>
